module.exports = __webpack_public_path__ + "img/logo-light.dea62e63.svg";